module.exports = __webpack_public_path__ + "static/media/w3.edc52e81.svg";